import { SET_USER_APPS, SET_USER_APPS_PERMISSION } from "../actions/types";

export const initialState = {
  userAppData: [],
  userAppsPermission: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER_APPS:
      return {
        ...state,
        userAppData: action.payload,
      };
    case SET_USER_APPS_PERMISSION:
      return{
        ...state,
        userAppsPermission: action.payload
      };
    default:
      return state;
  }
}
